<template>

    <div class="container">
        <h1 class="my-5">{{msg}}</h1>
        <div class="alert alert-primary" role="alert">
            A simple primary alert—check it out!
        </div>
        <div class="alert alert-secondary" role="alert">
            A simple secondary alert—check it out!
        </div>
        <div class="alert alert-success" role="alert">
            A simple success alert—check it out!
        </div>
        <div class="alert alert-danger" role="alert">
            A simple danger alert—check it out!
        </div>
        <div class="alert alert-warning" role="alert">
            A simple warning alert—check it out!
        </div>
        <div class="alert alert-info" role="alert">
            A simple info alert—check it out!
        </div>
        <div class="alert alert-light" role="alert">
            A simple light alert—check it out!
        </div>
        <div class="alert alert-dark" role="alert">
            A simple dark alert—check it out!
        </div>
    </div>

</template>

<script>
    export default {
        name: "Alerts",
        data() {
            return {
                msg: 'Alerts'
            }
        }
    }
</script>

<style lang="scss">
    @import "../assets/scss/variables";

    .alert {
        margin-bottom: 2rem;

        &-primary {
            background-color: $alert-blue;
            border-color: $alert-blue;
        }
        &-secondary {
            background-color: $alert-gray;
            border-color: $alert-gray;
        }
        &-success {
            background-color: $alert-green;
            border-color: $alert-green;
        }
        &-danger {
            background-color: $alert-pink;
            border-color: $alert-pink;
        }
        &-warning {
            background-color: $alert-yellow;
            border: $alert-yellow;
        }
        &-info {
            background-color: $alert-teal;
            border-color: $alert-teal;
        }
        &-light {
            background-color: $alert-light-gray;
            border-color: $alert-light-gray;
        }
        &-dark {
            background-color: $alert-dark-gray;
            border-color: $alert-dark-gray;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/Alerts.vue